import { Component, OnInit, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ServiceModel } from 'src/app/store/self-diagnostic/service-catalog/model';
import { List } from '../../../../../../core/infrastructure/linq';
import { ServiceCatalogFacade } from '../../../../../../store/self-diagnostic/service-catalog/facade';
import { IService } from '../../interfaces/service.interface';
import { Title } from '@angular/platform-browser';
import { UserModel } from '../../../../../../store/user/model';
import { AppConstants } from '../../../../../../core/constants/app-constants';
import { UserFacade } from '../../../../../../store/user/facade';
import notify from 'devextreme/ui/notify';

@Component({
  selector: 'app-admin-service-catalog',
  templateUrl: './service-catalog.component.html',
  styleUrls: ['./service-catalog.component.scss'],
  host: {
    class: 'p-4',
  },
  standalone: false,
})
export class ServiceCatalogComponent implements OnInit {
  translate = inject(TranslateService);
  private facade = inject(ServiceCatalogFacade);
  private titleService = inject(Title);
  private userFacade = inject(UserFacade);

  private servicesList: List<ServiceModel>;
  public services: IService[] = [];
  public user: UserModel;
  public isLanguageUa: boolean;

  public async ngOnInit() {
    // Page title
    this.translate.get('TITLE_MAIN').subscribe(value => {
      this.titleService.setTitle(value);
    });

    // Get current language
    this.userFacade.selected().subscribe(user => {
      this.user = { ...user };

      this.isLanguageUa = !this.user?.language || this.user?.language == AppConstants.LANGUAGE_UK;
    });

    this.facade.entities$.subscribe(s$ => {
      this.servicesList = new List<ServiceModel>(s$);

      this.services = this.servicesList
        .Select(
          s =>
            <IService>{
              id: s.id,
              code: s.code,
              nameUa: s.nameUa,
              nameRu: s.nameRu,
              isEnabled: s.isEnabled,
              categoryCode: s.category.code,
              categoryName: this.isLanguageUa ? s.category.nameUa : s.category.nameRu,
              categoryNameWeb: this.isLanguageUa ? s.category.webNameUa : s.category.webNameRu,
              masterCategoryCode: s.category.masterCategory?.code,
              masterCategoryName: this.isLanguageUa ? s.category.masterCategory?.nameUa : s.category.masterCategory?.nameRu,
              descriptionUa: s.descriptionUa,
              descriptionRu: s.descriptionRu,
              keyWords: s.keyWords,
            }
        )
        .ToArray();
    });
  }

  public rowClick($event) {
    if ($event.isExpanded) {
      $event.component.collapseRow($event.data.id);
    } else {
      $event.component.expandRow($event.data.id);
    }
  }

  public clickCheckBox($event, entity) {
    $event.event.preventDefault();
    $event.event.stopPropagation();

    if (entity.data.isEnabled) {
      this.facade.disable([entity.data.code]);
    } else {
      this.facade.enable([entity.data.code]);
    }
  }

  public sync() {
    this.facade.sync();
  }

  public onSave(service: ServiceModel) {
    this.facade.updateService(service);
  }
}
